import { Construction, ArrowLeft } from 'lucide-react';

interface DemoUnderConstructionProps {
  language: 'ja' | 'en';
  onBack: () => void;
}

export default function DemoUnderConstruction({ language, onBack }: DemoUnderConstructionProps) {
  const content = {
    ja: {
      title: '研究ポータル',
      subtitle: '準備中',
      description: 'このエリアは、承認された研究参加者専用です。',
      note: 'Apple審査用のデモコードでログインされています。実際の研究参加者のみがこのエリアにアクセスできます。',
      backButton: '戻る'
    },
    en: {
      title: 'Research Portal',
      subtitle: 'Under Construction',
      description: 'This area is for authorized research participants only.',
      note: 'You are logged in with an Apple review demo code. Only actual research participants can access this area.',
      backButton: 'Go Back'
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 w-full max-w-2xl text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-100 rounded-full mb-6">
          <Construction className="w-10 h-10 text-yellow-600" />
        </div>

        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          {t.title}
        </h1>
        <h2 className="text-xl text-gray-600 mb-6">
          {t.subtitle}
        </h2>

        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg mb-6 text-left">
          <p className="text-gray-700 mb-4">
            {t.description}
          </p>
          <p className="text-sm text-gray-600">
            {t.note}
          </p>
        </div>

        <div className="flex flex-col gap-4">
          <button
            onClick={onBack}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors shadow-lg"
          >
            <ArrowLeft className="w-5 h-5" />
            {t.backButton}
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            {language === 'ja' ? '© 2025 SNS Launcher 研究プロジェクト' : '© 2025 SNS Launcher Research Project'}
          </p>
        </div>
      </div>
    </div>
  );
}
